import styled from '@emotion/styled';
import colors from '../../../styling/colors';

const Header = styled.p`
  color: ${colors('lapel')};
  align: center;
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 1.5rem;
  letter-spacing: 0.125rem;
  text-transform: uppercase;
  margin: 0;
`;

export default Header;
